// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__7j0l4","footer":"ReportModalFilter_footer__1W8bm"};